import { Component } from 'react'
import { Flex, Box } from 'reflexbox'
import moment from 'moment'

import * as h from 'h'

import styles from './styles.scss'

export default class Footer extends Component {
  shouldComponentUpdate () {
    return false
  }

  render () {
    return h.footer(h.ca(styles.footer),
      h.h(Flex, { align: 'center' },
        h.h(Box, { auto: true, m: 2 },
          `©${moment().format('Y')} `,
          'UConn Office of the Vice President for Research'),
        h.h(Box, { m: 2 },
          'Designed and developed by [squared labs]')))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Footer/index.js